import { ref } from 'vue';
import { FilterSelectionStateCommittedEvent } from '@/filters/events/FilterSelectionStateCommittedEvent';
import { ISubscriber } from '@studyportals/event-aggregation-service-interface';
import { FilterKey } from '@studyportals/search-filters';
import { EventAggregationService } from '../../platform/EventAggregationService';
import { injectable } from 'inversify';
import { FilterSelection } from './FilterSelection';

@injectable()
export class FilterCounter implements ISubscriber<FilterSelectionStateCommittedEvent> {
	private readonly filterSelection: FilterSelection;

	public readonly count = ref(0);
	private readonly subFilters = [FilterKey.AREA];

	public constructor(eventAggregationService: EventAggregationService, filterSelection: FilterSelection) {
		this.filterSelection = filterSelection;
		this.performCount();

		eventAggregationService.subscribeTo(FilterSelectionStateCommittedEvent.EventType, this);
	}

	public notify(): void | Promise<void> {
		this.performCount();
	}

	private performCount(): void {
		const selection = this.filterSelection.state.reactive.identifySelectedFilterKeys();
		const mainFiltersSelection = selection.filter((filter) => !this.subFilters.includes(filter));

		this.count.value = mainFiltersSelection.length;
	}
}
